import {BottomNavbar} from "../../features/measure/components/BottomNavbar";

export const PlatformBottomNavbar = ({
  selectedTab,
  onClickLeftButton = () => null,
  onClickRightButton = () => null,
}) => {
  const buttons = [
    {
      label: '提出申請',
      name: 'new-application',
      icon: 'fa-plus',
      onClick: onClickLeftButton,
    },
    {
      label: '我的申請',
      name: 'list-application',
      icon: 'fa-rectangle-list',
      onClick: onClickRightButton,
    }
  ]
  return (
    <BottomNavbar
      buttons={buttons}
      selectedTab={selectedTab}
    />
  )
}
